'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getRows;

var _getRowSelectionInputType = require('./getRowSelectionInputType');

var _getRowSelectionInputType2 = _interopRequireDefault(_getRowSelectionInputType);

var _computeUniqueRowKey = require('./computeUniqueRowKey');

var _computeUniqueRowKey2 = _interopRequireDefault(_computeUniqueRowKey);

var _isSelectedRow = require('../selector/isSelectedRow');

var _isSelectedRow2 = _interopRequireDefault(_isSelectedRow);

var _isDisabledRow = require('../selector/isDisabledRow');

var _isDisabledRow2 = _interopRequireDefault(_isDisabledRow);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getKey(row, keyField) {
  if (row.key) {
    return row.key;
  }

  return (0, _computeUniqueRowKey2.default)(row, keyField);
}

function getRows() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$rows = params.rows,
      rows = _params$rows === undefined ? [] : _params$rows,
      maxRowSelection = params.maxRowSelection,
      keyField = params.keyField,
      selectedRowsKeys = params.selectedRowsKeys;
  var inputType = (0, _getRowSelectionInputType2.default)(maxRowSelection, rows.length);
  return rows.map(function (row) {
    var key = getKey(row, keyField);
    return {
      key: key,
      inputType: inputType,
      isSelected: (0, _isSelectedRow2.default)(selectedRowsKeys, key),
      isDisabled: (0, _isDisabledRow2.default)({
        rowKeyValue: key,
        maxRowSelection: maxRowSelection,
        selectedRowsKeys: selectedRowsKeys
      })
    };
  });
}